import React from 'react';
import styles from './Footer.module.scss';
import { Container, Row, Col } from 'react-grid-system';
import Image from 'next/image';
import { Text, IconPlace, IconPhone, IconWhats } from 'condolivre-ds';

const Footer = () => {
    return (
        <div className={styles.footerContainer}>
            <Container className={styles.container}>
                <Row>
                    <Col className={styles.footerText}>
                        <Image src="/images/Logo_condolivre_pos.png" width="200" height="52" />
                        <Text size="v_16" weight="v_500" color="gray_700">
                            A CondoLivre Análise de Crédito e Cobrança Ltda, inscrita sob o CNPJ
                            28.314.050/0001-62, é uma Fintech especializada em <br /> soluções de
                            crédito para o universo de condomínios.
                        </Text>
                    </Col>
                </Row>
                <Row>
                    <Col lg={4} className={styles.left}>
                        <Text weight="v_500" color="gray_800" size="v_16">
                            Nosso endereço
                        </Text>
                        <Text
                            size="v_14"
                            color="gray_800"
                            weight="v_500"
                            className={[styles.tip, styles.address].join(' ')}>
                            <IconPlace />
                            <span>
                                Avenida Presidente Juscelino Kubitschek nº 1830 Sala 51 - Bloco 01 -
                                Condomínio Edifício São Luiz <br /> Vila Nova Conceição, São Paulo
                                SP - CEP: 04543-900
                            </span>
                        </Text>
                    </Col>
                    <Col lg={4} className={styles.center}>
                        <Text weight="v_500" color="gray_800" size="v_16">
                            Central de atendimento
                        </Text>
                        <Text size="v_24" color="gray_800" weight="v_500" className={styles.tip}>
                            <IconPhone />
                            <span>(011) 3097-9918</span>
                        </Text>
                    </Col>
                    <Col lg={4} className={styles.right}>
                        <Text weight="v_500" color="gray_800" size="v_16">
                            Equipe de suporte
                        </Text>
                        <Text size="v_24" color="gray_800" weight="v_500" className={styles.tip}>
                            <IconWhats />
                            <span>(011) 91851-3094</span>
                        </Text>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Footer;
